import React, { useEffect, useState } from 'react'
import {DeliveryDetailsRequest, StatusChangeRequest, ResendotpRequest} from '../../redux/reducer/FetchDataReducer'
import { useSelector, useDispatch } from 'react-redux'
import { NavLink,useNavigate,useParams } from 'react-router-dom'
import Loader from '../../utils/Loader'
import { toast } from 'react-toastify';
import AfterLoginTopbar from '../header/AfterLoginTopbar'
import { IMAGE } from '../../utils/Theme'
import Modal from 'react-bootstrap/Modal';

const OrderDetails = () => {
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [otp1, setotp1] = useState('')
    const [otp2, setotp2] = useState('')
    const [otp3, setotp3] = useState('')
    const [otp4, setotp4] = useState('')


    const handleClose = () => setShow(false);
    const fetchReducer = useSelector((state) => state.FetchDataReducer)
    let {id} = useParams();
    const dispatch = useDispatch()
    let navigate = useNavigate()

    const phoneNumber = fetchReducer.detailsResponse?.data?.order?.phone_number; // Replace this with the phone number you want to contact
    const message = 'Hello, I am contacting you from the canably agent!';
  
    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

    console.log(fetchReducer.detailsResponse)

    useEffect(()=>{
        let obj = id
        dispatch(DeliveryDetailsRequest(obj))
        setShow1(false)
    },[fetchReducer.statusResponse])


    const ConfirmHandle = (status)=>{
        let obj = {
            "uuid": id,
            "status": status
        }
        dispatch(StatusChangeRequest(obj))
        setShow(false)
    }

    const ConfirmHandlefordelivery = (status)=>{
        let obj = {
            "uuid": id,
            "status": status
        }
        dispatch(StatusChangeRequest(obj))

        if(fetchReducer.detailsResponse.status){
            setShow(false)
            setShow1(true)
        }
        
    }


    let tabChange = function(val){
        let ele = document.querySelectorAll('input');
        if(ele[val-1].value != ''){
          ele[val].focus()
        }else if(ele[val-1].value == ''){
          ele[val-2].focus()
        }   
     }

     const VerifyHandler = ()=>{
  
        var inputOtp = otp1 + otp2 + otp3 + otp4
        if(otp1 == '')
        {
          toast.error("Field is required");
        }  else {
            let obj = {
                "uuid": id,
                "status": 'delivered',
                "otp":inputOtp
            }
            dispatch(StatusChangeRequest(obj))
            setShow(false)
        }
        
    }

    const ResendOtp = ()=>{
      let obj = {
        "uuid": id,
        "status": 'outfordelivery',
        "resend":'yes'
    }
    dispatch(ResendotpRequest(obj))
    }

   


  return (
    <>
         <AfterLoginTopbar
       title={`Welcome ${fetchReducer.profileResponse?.data?.first_name}`}
      acttion="menu"
      />
       <Loader visible={fetchReducer.isloading} />
       <div className='comon-body'>
       <div className='order-card'>
        <div className='order-card-header'>
            <div className='order-card-header-sl'>
                1
            </div>
            <div className='order-card-header-info'>
                <h5>Order: <span>{fetchReducer.detailsResponse?.data?.order?.order_no}</span></h5>
                <h5>Order Amt: <span>$ {fetchReducer.detailsResponse?.data?.order?.total}</span></h5>
            </div>
        </div>
        <div className='order-card-body'>
            <div className='b-plist'>
                <span>
                    <img src={IMAGE.location}/>
                </span>
                <p>{fetchReducer.detailsResponse?.data?.order?.address}
                {/* <NavLink to=""  target='_blank'><i className="fa-solid fa-location-dot"></i></NavLink> */}
                </p>
            </div>
            <div className='b-plist'>
                <span>
                    <img src={IMAGE.user}/>
                </span>
                <p>Delivery To: {fetchReducer.detailsResponse?.data?.order?.name} 
             
                
                </p>
            </div>
            <div className='b-plist'>
                <span>
                    <img src={IMAGE.user}/>
                </span>
                <p>Customer Phone: {fetchReducer.detailsResponse?.data?.order?.phone_number}
                
                <NavLink to={url}  target='_blank'><i className="fa-brands fa-square-whatsapp"></i></NavLink>
            
                </p>
            </div>
            <div className='success-d text-left'>
           
              <span>No of Items {fetchReducer.detailsResponse?.data?.order?.quantity}</span>
            </div>
        </div>
        <div className='text-center py-3'>
            {fetchReducer.detailsResponse?.data?.delivery_status
 == 1 &&
                 <button className='accept-btn btn' onClick={()=>setShow(true)}>Switch to shipped</button>
            }
           {fetchReducer.detailsResponse?.data?.delivery_status
 == 2 &&
                 <button className='accept-btn btn' onClick={()=>setShow(true)}>Out for delivery</button>
            }

{fetchReducer.detailsResponse?.data?.delivery_status
 == 3 &&
 <button className='accept-btn btn' onClick={()=>setShow(true)}>Deliver It</button>
            }


{fetchReducer.detailsResponse?.data?.delivery_status
 == 4 &&
           <h5 className='text-success'><i className="fa-solid fa-circle-check"></i> Delivered</h5>
            }

        </div>
        
    </div>
       </div>

       <Modal show={show} onHide={handleClose} centered size="sm" className='AlertMsg'>
    <Modal.Header>
      <Modal.Title><i className="fa-solid fa-triangle-exclamation"></i> Alert !</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <h4>Change status to {fetchReducer.detailsResponse?.data?.delivery_status
 == 1 ? "shipped" : fetchReducer.detailsResponse?.data?.delivery_status == 2 ? 'out for delivery' : 'delivered' } ?</h4>
      <ul>
      <li>
        <button onClick={handleClose} className='btn btn-md btn-danger'>
            Cancel
        </button>
     
      </li>
      <li>
      {fetchReducer.detailsResponse?.data?.delivery_status
 == 1 &&
      <button className='btn btn-md btn-success' onClick={()=>ConfirmHandle('shipped')}>
           Confirm
        </button>
}
{fetchReducer.detailsResponse?.data?.delivery_status
 == 2 &&
      <button className='btn btn-md btn-success' onClick={()=>ConfirmHandle('outfordelivery')}>
           Confirm
        </button>
}

{fetchReducer.detailsResponse?.data?.delivery_status
 == 3 &&
      <button className='btn btn-md btn-success' onClick={()=>ConfirmHandlefordelivery('delivered')}>
           Confirm
        </button>
}


      </li>
    </ul>

    </Modal.Body>
  
   
  </Modal>


  <Modal show={show1} onHide={handleClose}  size="sm" className='otpModal'>

    <Modal.Body>
      <button className='closebtn' onClick={()=>setShow1(false)}><i className="fa-solid fa-circle-xmark"></i></button>

     <h3>Enter OTP</h3>
    <p>Please enter 4 digit OTP to verify client</p>
    <ul className="otp-l">
                    <li>
                    <input
                  type="text"
                  maxLength="1"
                  onKeyUp={()=>tabChange(1)}
                  className="form-control input-style"
                  placeholder="-"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={otp1}
                  onChange={(e) => {
                    setotp1(e.target.value);
                }}
                /> 
                    </li>
                    <li>
                    <input
                  type="text"
                  maxLength="1"
                  onKeyUp={()=>tabChange(2)}
                  className="form-control input-style"
                  placeholder="-"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={otp2}
                  onChange={(e) => {
                    setotp2(e.target.value);
                    
                }}
                /> 
                    </li>
                    <li>
                    <input
                  type="text"
                  maxLength="1"
                  onKeyUp={()=>tabChange(3)}
                  className="form-control input-style"
                  placeholder="-"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={otp3}
                  onChange={(e) => {
                    setotp3(e.target.value);
                   
                }}
                /> 
                    </li>
                    <li>
                    <input
                  type="text"
                  maxLength="1"
                  onKeyUp={()=>tabChange(4)}
                  className="form-control input-style"
                  placeholder="-"
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={otp4}
                  onChange={(e) => {
                    setotp4(e.target.value);
                    
                }}
                /> 
                    </li>
                </ul>
                <div className='form-group'>
                <button type='button' className='login-btn' onClick={VerifyHandler}>VERIFY</button>
            </div>

            <div className='form-group text-center'>
                <button type='button' className='resendotpbtn' onClick={ResendOtp}>Resend OTP</button>
            </div>
    </Modal.Body>
  
   
  </Modal>

    </>
  )
}

export default OrderDetails